import { filterFunction, FiltersType, LocationsMappingsType } from "~/react/components/search/filters"
import { ResultType } from "~/react/components/multi_domain_search/result"
import { useMemo } from "react"

export const useJobTitleSuggestions = (
  results: ResultType[],
  filters: FiltersType,
  locationsMappings: LocationsMappingsType,
  revealedIds: number[],
) => {
  const resultsFilteredByEverythingExceptJobTitles = useMemo(() => {
    return Array.from(
        filterFunction(
          results,
          filters,
          locationsMappings,
          revealedIds,
          ["job_title"],
        )
          .map((result) => result.jobTitle)
          .filter(Boolean),
    ).sort()
  }, [results, filters, locationsMappings, revealedIds])

  return resultsFilteredByEverythingExceptJobTitles
}
